import { useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "jalali-moment";
import useStore from "../../features/store";

const Transactions = () => {
  const { transactions, fetchTransactions }: any = useStore();

  useEffect(() => {
    if (!transactions) fetchTransactions();
  }, [transactions]);

  return (
    <div className="flex-1 mt-10">
      <div className="breadcrumbs text-sm mb-4">
        <ul>
          <li>
            <Link to="/">صفحه اصلی</Link>
          </li>
          <li className="font-[900]">پرداخت‌ها</li>
        </ul>
      </div>

      <div className="overflow-x-auto mt-10">
        <table className="table">
          <thead>
            <tr>
              <th></th>
              <th>تاریخ</th>
              <th>مقدار</th>
              <th>وضعیت</th>
              <th>کد پیگیری</th>
            </tr>
          </thead>
          <tbody>
            {transactions?.results.map((trs: any, idx: number) => (
              <tr key={idx}>
                <th>{idx + 1}</th>
                <td className="text-nowrap">
                  {moment
                    .from(trs?.update_at_jalali, "fa", "DD-MM-YYYY")
                    .locale("fa")
                    .format("jYYYY/jMM/jDD")}
                </td>
                <td className="text-nowrap">
                  {trs.amount.toLocaleString()} تومان
                </td>
                <td className="text-nowrap">
                  {trs.status === "OnWait"
                    ? "در انتظار پرداخت"
                    : trs.status === "Paid"
                    ? "پرداخت شده"
                    : "کنسل شده"}
                </td>
                <td>{trs.station_code}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Transactions;
